<template>
  <section class="app-aproc">
    <v-container grid-list-xl v-scroll="onScroll" v-resize="onResize">
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">Consultar Processos até 2020</v-card-title>
            <v-card-text class="app-card-content">
              <v-alert
                outlined
                type="info"
                text
              >Digite o "Número de VIPROC" ou "Número da Arce" para pesquisar por processos gerados até 2020</v-alert>
              <br />
              <v-form
                ref="form"
                v-model="formModel.valid"
                lazy-validation
                @submit.prevent="onSubmit"
              >
                <v-row>
                  <v-col :md="3" :sm="3" :xs="12" cols="12" class="pb-0">
                    <v-select
                      :items="items"
                      label="Pesquisar por"
                      :rules="[rules.required]"
                      :item-value="'key'"
                      filled
                      rounded
                      dense
                      v-model="formModel.type"
                      @change="clearFieldNumber"
                    ></v-select>
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="12" cols="12" class="pb-0">
                    <v-text-field
                      type="text"
                      label="Número de Viproc *"
                      placeholder="Ex.: 0000000000/2020"
                      v-model="formModel.process"
                      :rules="[rules.required, rules.pattern]"
                      filled
                      rounded
                      dense
                      ref="process"
                      v-if="formModel.type === 'viproc'"
                    ></v-text-field>
                    <v-text-field
                      type="text"
                      label="Número da ARCE *"
                      placeholder="Ex.: XXXX/XXX/00/0000"
                      v-model="formModel.process"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                      ref="process"
                      v-else
                    ></v-text-field>
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="9" cols="12">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input
                      v-model="formModel.recaptcha"
                      :rules="[rules.required]"
                      style="margin-top: -25px;"
                    ></v-input>
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="3" cols="12">
                    <v-btn depressed block large color="primary" type="submit">Continuar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
          <div class="text-xs-center area-loading" v-if="isLoading">
            <v-progress-circular indeterminate color="primary" :size="20" :width="2"></v-progress-circular>
            <span class="text-loading">Buscando ...</span>
          </div>
        </v-flex>

        <div id="area-document"></div>

        <v-flex lg12 sm12 xs12 transition="fade-transition" id="card-document">
          <v-card outlined class="app-card" v-if="document">
            <v-card-title class="app-card-title">Detalhes do Documento</v-card-title>

            <v-card-text class="mt-10">
              <v-layout row wrap>
                <v-flex lg6 sm6 xs12>
                  <v-text-field
                    label="SCD N°"
                    :value="document.scdNumero + '/' + document.scdAno"
                    readonly
                  ></v-text-field>
                </v-flex>

                <v-flex lg6 sm6 xs12>
                  <v-text-field
                    label="Viproc N°"
                    :value="document.viprocNumero + '/' + document.viprocAno"
                    readonly
                    v-if="document.viprocNumero"
                  ></v-text-field>
                  <v-text-field label="Viproc N°" :value="'Sem Viproc N°'" readonly v-else></v-text-field>
                </v-flex>

                <v-flex lg6 sm6 xs12>
                  <v-text-field
                    label="Relator"
                    :value="
                      document.relator ? document.relator : 'NÃO HÁ RELATOR'
                    "
                    readonly
                  ></v-text-field>
                </v-flex>

                <v-flex lg6 sm6 xs12>
                  <v-text-field
                    label="Situação"
                    :value="document.dataEncerramento ? 'ENCERRADO' : 'ABERTO'"
                    readonly
                  ></v-text-field>
                </v-flex>

                <v-flex lg6 sm6 xs12>
                  <v-text-field label="Espécie" :value="document.especie" readonly></v-text-field>
                </v-flex>

                <v-flex lg6 sm6 xs12>
                  <v-text-field
                    label="Data de Criação"
                    v-model="document.dataCriacao"
                    type="date"
                    readonly
                  ></v-text-field>
                </v-flex>

                <v-flex lg6 sm6 xs12>
                  <v-text-field label="Setor Origem" v-model="document.setorOrigem" readonly></v-text-field>
                </v-flex>

                <v-flex lg6 sm6 xs12>
                  <v-text-field label="Assunto" v-model="document.assunto" readonly></v-text-field>
                </v-flex>

                <v-flex lg12 sm12 xs12>
                  <v-textarea outline label="Descrição" v-model="document.descricao" readonly></v-textarea>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex
          lg12
          sm12
          xs12
          v-if="tramitations && tramitations.length > 0"
          transition="fade-transition"
        >
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">Histórico de Tramitações</v-card-title>

            <v-card-text id="card-text">
              <v-timeline align-top :dense="modeTimeline">
                <v-timeline-item
                  v-for="(tramitation, key) in tramitations"
                  :key="key"
                  :color="key === 0 ? '#1976d2' : '#e0e0e0'"
                  small
                >
                  <v-card :color="key === 0 ? '#1976d2' : '#e0e0e0'" dark outlined>
                    <v-card-title
                      class="title title-card"
                      :class="key === 0 ? 'title-card--first' : ''"
                    >
                      {{
                      changeStatusTramitation(key, tramitation.status)
                      }}
                    </v-card-title>
                    <v-card-text class="white text--primary">
                      <div>
                        <span>
                          <strong>Motivo:</strong>
                          {{ tramitation.motivo }}
                        </span>
                      </div>

                      <div>
                        <span>
                          <strong>Setor Origem:</strong>
                          {{ tramitation.setorOrigem }} -
                          {{ tramitation.dataDespacho | formatDate("LLL") }}
                        </span>
                      </div>

                      <div>
                        <span>
                          <strong>Setor Destino:</strong>
                          {{ tramitation.setorDestino }} -
                          {{ tramitation.dataRecebimento | formatDate("LLL") }}
                        </span>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>

              <div class="text-xs-center">
                <v-progress-circular
                  v-if="loadingTramitations"
                  indeterminate
                  color="primary"
                  class="loading-tramitation"
                ></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import GlobalStore from "@/store/modules/global";
import DocumentService from "@/services/document.service";
import TramitationService from "@/services/tramitation.service";

import { mask } from "vue-the-mask";

import { delay } from "rxjs/operators";

import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";

export default Vue.extend({
  components: {
    VueRecaptcha
  },
  directives: {
    mask
  },
  metaInfo: {
    title: "Consulta de Processos - Central de Serviços"
  },
  data: () => ({
    siteKey: VUE_APP_RECAPTCHA_KEY,
    isLoading: false,
    loadingTramitations: false,
    formModel: {
      valid: false,
      recaptcha: null,
      type: "numero_arce",
      process: ""
    },
    document: null,
    tramitations: [],
    rules: {
      required: value => !!value || "Esse campo deve ser preenchido",
      pattern: value =>
        !!value.match(/^([0-9])*\/[0-9]{4}$/) ||
        "Esse campo está fora do padrão"
      // patternArce: value =>
      //   !!value.match(/^([A-Z]){4}*\/([A-Z]){2}*\/([0-9]){2}*\/([0-9]){4}$/) ||
      //   "Esse campo está fora do padrão"
    },
    page: 0,
    size: 15,
    endTramitations: false,
    error: "",
    urlLogo: "img/logo-arce.png",
    modeTimeline: false,
    items: [
      { key: "viproc", text: "Viproc" },
      { key: "numero_arce", text: "Número ARCE" }
    ]
  }),
  filters: {
    formatDate: (dateToFormat, pattern) => moment(dateToFormat).format(pattern)
  },
  methods: {
    clearFieldNumber() {
      this.formModel.process = null;
    },
    verifyRecaptcha(value) {
      this.formModel.recaptcha = value;
      this.initData();
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.formModel.recaptcha = null;
    },
    initData() {
      const { query } = this.$route;
      if (query && query.numero) {
        this.formModel.process = query.numero;
        this.onSubmit();
      }
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.endTramitations = false;
        this.page = 0;
        this.tramitations = [];
        this.loadData();
      }
    },
    loadData() {
      this.isLoading = true;
      const process = {
        type: this.formModel.type,
        numero: this.formModel.process
      };
      const recaptcha = this.formModel.recaptcha;
      //this.$router.push({ name: "", query: { numero: process } });
      DocumentService.findByViprocOrNumeroArce(process, recaptcha).subscribe(
        response => {
          this.document = response;
          this.isLoading = false;
          this.expiredRecaptcha();
          this.scrollToDocument();
          this.loadTramitacoes();
        },
        error => {
          this.expiredRecaptcha();
          this.document = null;
          this.isLoading = false;
        }
      );
    },
    loadTramitacoes() {
      TramitationService.findByProcessoId(
        this.document.id,
        this.page,
        this.size
      ).subscribe(
        response => {
          if (this.document) {
            this.tramitations = response;
          }
          this.isLoading = false;
        },
        error => {
          this.expiredRecaptcha();
          this.tramitations = [];
          this.isLoading = false;
        }
      );
    },
    clear() {
      this.document = null;
      this.tramitations = [];
      this.formModel.process = "";
    },
    onScroll() {
      const { documentElement } = document;
      let bottomOfWindow =
        documentElement.scrollTop + window.innerHeight ===
        documentElement.offsetHeight;

      if (
        bottomOfWindow &&
        !this.endTramitations &&
        this.tramitations &&
        this.document
      ) {
        this.page += 1;
        this.loadingTramitations = true;
        TramitationService.findByProcessoId(
          this.document.id,
          this.page,
          this.size
        )
          .pipe(delay(1000))
          .subscribe(
            tramitations => {
              if (tramitations.length > 0) {
                this.tramitations.push(...tramitations);
              } else {
                this.endTramitations = true;
              }
            },
            error => {
              this.tramitations = [];
              throw error;
            },
            () => {
              this.loadingTramitations = false;
            }
          );
      }
    },
    onResize() {
      this.verifyWidth(window.innerWidth);
    },
    verifyWidth(size) {
      this.modeTimeline = size <= 767;
    },
    changeStatusTramitation(key, status) {
      if (key === 0 && this.document && this.document.dataEncerramento) {
        return "FINALIZADO";
      } else if (key === 0) {
        return "RECEBIDO (FASE ATUAL)";
      } else {
        return status;
      }
    },
    scrollToDocument() {
      this.$vuetify.goTo("#card-document");
    }
  },
  mounted() {
    moment.locale("pt-br");
    this.verifyWidth(window.innerWidth);
    //this.initData();
  }
});
</script>

<style lang="scss">
input {
  text-transform: uppercase;
}
.area-loading {
  text-align: center;
  margin: 10px;
  .v-progress-circular {
    margin-right: 10px;
  }
}
.loading-tramitation {
  margin: auto;
  display: table;
}
</style>
